import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Command = {
  groupId: string;
  columnId: string;
};

async function deleteQuoteColumn(command: Command) {
  const { error } = await apiClient
    .from('quote_comparison_columns')
    .delete()
    .eq('id', command.columnId);

  if (error) {
    throw error;
  }
}

export function useDeleteQuoteColumn() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteQuoteColumn,
    onSuccess: (_data, command) => {
      queryClient.invalidateQueries({ queryKey: keys.columns(command.groupId) });
      queryClient.invalidateQueries({ queryKey: keys.groupQuotes(command.groupId) });
      enqueueSnackbar('Critère supprimé.', 'success');
    },
  });
}
